module.exports = __webpack_public_path__ + "img/pool.24d96bad.svg";